export default __webpack_public_path__ + "static/media/ico-exclamation-red.6b3ed3fa.svg";